<mat-dialog-content>
    <div class="fw-500 mapfre-fs-m dark mapfre-hide-mobile mapfre-hide-tablet">{{ 'FILTER_MODAL.FILTER_BY' | translate
        }}</div>
    <div class="fw-500 mapfre-fs-l dark mapfre-hide-desktop flex jc-sb ai-c">{{ 'FILTER_MODAL.FILTERS' | translate }}
        <button (click)="close()" matSuffix mat-icon-button aria-label="Clear">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>
    <div *ngIf="!ctx.isMobile && bookingTypes.length > 0" class="mapfre-fs-xxs dark-light mapfre-mt-sm text-uppercase">
        {{ 'FILTER_MODAL.TYPE_CENTER' | translate }}
    </div>
    <div *ngIf="ctx.isMobile && bookingTypes.length > 0" class="mapfre-fs-xxs dark-light mapfre-mt-sm text-uppercase">
        {{ 'FILTER_MODAL.WHAT_NEED' | translate }}</div>
    <div>
        <mat-radio-group [(ngModel)]="bookingType" aria-labelledby="filter-radio-group-label"
            class="filter-radio-group">
            <mat-radio-button class="filter-radio-button" *ngFor="let type of bookingTypes || []" [value]="type">
                {{type.label}}
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="mapfre-fs-xxs dark-light mapfre-mt-m mapfre-mb-sm text-uppercase">{{'FILTER_MODAL.MAX_DISTANCE' |
        translate}}</div>
    <div class="dark slider">
        <div class="mapfre-fs-xs">1km</div>
        <mat-slider max="50" [displayWith]="utils.formatSliderLabelKm" thumbLabel [(ngModel)]="radio"></mat-slider>
        <div class="mapfre-fs-xs">50km</div>
    </div>
    <div class="mapfre-fs-xxs dark-light mapfre-mt-l text-uppercase">{{'FILTER_MODAL.SEARCH_CENTER' | translate}}</div>
    <div class="mapfre-mt-s">
        <mat-form-field class="w-100" appearance="outline">
            <input [(ngModel)]="centerName" placeholder="Escribe el nombre del centro" matInput type="text">
            <button matSuffix mat-icon-button aria-label="Clear">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div  *ngIf="showSpecialistSearchInput()" class="mapfre-fs-xxs dark-light mapfre-mt-s text-uppercase">{{'FILTER_MODAL.SEARCH_DOCTOR' | translate}}</div>
    <div  *ngIf="showSpecialistSearchInput()" class="mapfre-mt-s">
        <mat-form-field class="w-100" appearance="outline">
            <input [(ngModel)]="doctorName" placeholder="Escribe el nombre del especialista" matInput type="text">
            <button matSuffix mat-icon-button aria-label="Clear">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>

    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex jc-sb buttons mapfre-hide-mobile mapfre-hide-tablet w-100">
        <app-button size="medium" type="outline" (click)="onCleanFilters()" [text]="'Borrar todo'">
        </app-button>
        <app-button size="medium" type="dark" (click)="onSearch()" [text]="'Aceptar'"></app-button>
    </div>
    <div class="mapfre-hide-desktop flex w-100 mapfre-mt-sm">
        <app-button type="outline" [mr]="10" (click)="onCleanFilters()" [text]="'Borrar todo'"></app-button>
        <app-button type="dark" [ml]="10" (click)="onSearch()" [text]="'Aceptar'"></app-button>
    </div>

</mat-dialog-actions>
